import {
  OPPORTUNITY_TYPE_CONFIG,
  buildDurationTypeLabels,
  OPPORTUNITY_TYPE_INFO,
} from '@/entities/opportunity';
import type { DurationTypeCardProps } from './DurationType.types';
import { useTranslation } from 'react-i18next';

export const DurationTypeCard = ({ data }: DurationTypeCardProps): React.JSX.Element => {
  const { t } = useTranslation('analysis');

  const config = OPPORTUNITY_TYPE_CONFIG[data.value];
  const Icon = config.Icon;

  return (
    <div className={`p-6 grid grid-cols-1 gap-4 ${config.bg} rounded-lg h-full`}>
      {/* Header */}
      <div className="flex items-center gap-2">
        <div className={`flex items-center justify-center rounded-sm w-8 h-8 ${config.tileBg}`}>
          <Icon className={`size-4 ${config.tileIcon}`} />
        </div>
        <p className={`${config.text} font-medium text-base`}>
          {t('socialMediaOpportunitiesWidget.durationTypeCard.durationOpportunity', {
            durationLabel: buildDurationTypeLabels()[data.value],
          })}
        </p>
      </div>

      {/* Reasoning */}
      <p className="text-base text-foreground-alt">{data.reasoning}</p>

      {/* Impact */}
      <div className="p-4 rounded-lg bg-card grid grid-cols-1 gap-2">
        <p className="text-sm font-medium text-foreground mb-1">
          {t('socialMediaOpportunitiesWidget.durationTypeCard.recommendedTimeframe')}
        </p>
        <p className="text-base text-foreground-alt">
          {OPPORTUNITY_TYPE_INFO[data.value].description}
        </p>
      </div>
    </div>
  );
};
